export default __webpack_public_path__ + "static/media/flag.096c0012.svg";